<template>
    <section class="app">
        <section class="header">
            <div>
                <img src="../../assets/imgs/logo.svg" height="50">
            </div>
            <div></div>
        </section>
        <section class="body">
            <div class="login">
                <div class="title">
                    <h1>Validar Token</h1>
                    <p>Informe o token que enviamos para o seu e-mail</p>
                </div>
                <form @submit.prevent="checkToken">
                    <div class="msg" v-if="message">{{message}}</div>
                    <div class="input-box">
                        <input id="input-password" type="text" placeholder="Digite o token" v-model="form.code">
                        <label for="input-password">
                            <span>Token</span>
                        </label>
                    </div>
                    <div class="control">
                        <button type="submit" :class="indicatorSave">Continuar</button>
                    </div>
                </form>
                <div class="link-back">
                    <router-link to="login"><i class="fal fa-long-arrow-left"></i> Ir para o login</router-link>
                </div>
            </div>
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg" height="20">
            </div>
        </section>
    </section>
</template>

<script>
    import {login} from '@/services'
    export default {
        name: 'login',
        components: {},
        data(){
            return {
                load: false,
                message: '',
                form: {
                    code: '',
                    user_id: '',
                    type: '',
                }
            }
        },
        computed: {
            indicatorSave(){
                return this.load ? 'load' : ''
            },
        },
        methods: {
            checkToken(){
                this.load = true
                login.checkPassToken(this.form).then( () => {
                    this.$router.push({
                        name: 'register-new-password',
                        params: {
                            user: this.form.user_id,
                            type: this.form.type
                        }
                    })
                    this.load = false
                }, error => {
                    this.message = error.response.data.message
                    this.load = false
                })
            }
        },
        created(){
            this.form.user_id = this.$route.params.user
            this.form.type = this.$route.params.type

            if(!this.form.user_id){
                this.$router.push({
                    name: 'login',
                })
            }
        }
    }
</script>



<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
